"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CtaStatus = require("./constants/CtaStatus");
var _CartStatus = require("./constants/CartStatus");
var _button = _interopRequireDefault(require("@ux/button"));
var _ctas = require("./utilities/ctas");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AddToCartComponent = ({
  onManagerActionOrStateChange,
  domain,
  eidPrefix,
  getClassNames,
  getHandleOnClick,
  handleKeyDown,
  ctaIconSize,
  addProps,
  CustomAddToCartComponent,
  openButton,
  addToCartProps,
  formatMessage,
  showGavelIcon = false
}) => {
  if (CustomAddToCartComponent) {
    return /*#__PURE__*/_react.default.createElement(CustomAddToCartComponent, {
      openButton: openButton,
      domain: domain,
      formatMessage: formatMessage,
      eidPrefix: eidPrefix,
      getClassNames: getClassNames,
      getHandleOnClick: getHandleOnClick,
      handleKeyDown: handleKeyDown,
      ctaIconSize: ctaIconSize,
      addProps: addProps,
      onManagerActionOrStateChange: onManagerActionOrStateChange,
      showGavelIcon: showGavelIcon
    });
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    addToCartProps,
    onClick: onManagerActionOrStateChange
  }, "Default Add To Cart");
};
AddToCartComponent.propTypes = {
  onManagerActionOrStateChange: _propTypes.default.func,
  openButton: _propTypes.default.bool,
  ctaIconSize: _propTypes.default.number,
  handleKeyDown: _propTypes.default.func,
  getHandleOnClick: _propTypes.default.func,
  getClassNames: _propTypes.default.func,
  addProps: _propTypes.default.object,
  domain: _propTypes.default.object,
  eidPrefix: _propTypes.default.string,
  CustomAddToCartComponent: _propTypes.default.func,
  addToCartProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func,
  showGavelIcon: _propTypes.default.bool
};
const RemoveFromCartComponent = ({
  CustomRemoveFromCartComponent,
  ContinueToCartComponent,
  domain,
  stopPropagation,
  useDefaultContinueToCart,
  host,
  defaultContinueToCartSkipConfig,
  getClassNames,
  eidPrefix,
  getHandleOnClick,
  handleKeyDown,
  ctaIconSize,
  removeProps,
  removeFromCartProps,
  customOnClick,
  onManagerActionOrStateChange,
  formatMessage
}) => {
  if (CustomRemoveFromCartComponent) {
    return /*#__PURE__*/_react.default.createElement(CustomRemoveFromCartComponent, {
      formatMessage: formatMessage,
      ContinueToCartComponent: ContinueToCartComponent,
      domain: domain,
      customOnClick: customOnClick,
      stopPropagation: stopPropagation,
      useDefaultContinueToCart: useDefaultContinueToCart,
      host: host,
      defaultContinueToCartSkipConfig: defaultContinueToCartSkipConfig,
      getClassNames: getClassNames,
      eidPrefix: eidPrefix,
      getHandleOnClick: getHandleOnClick,
      handleKeyDown: handleKeyDown,
      ctaIconSize: ctaIconSize,
      removeProps: removeProps,
      onManagerActionOrStateChange: onManagerActionOrStateChange
    });
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    removeFromCartProps,
    onClick: onManagerActionOrStateChange
  }, "Default Remove From Cart");
};
RemoveFromCartComponent.propTypes = {
  CustomRemoveFromCartComponent: _propTypes.default.func,
  ContinueToCartComponent: _propTypes.default.func,
  domain: _propTypes.default.object,
  stopPropagation: _propTypes.default.bool,
  useDefaultContinueToCart: _propTypes.default.bool,
  host: _propTypes.default.string,
  defaultContinueToCartSkipConfig: _propTypes.default.bool,
  getClassNames: _propTypes.default.func,
  eidPrefix: _propTypes.default.string,
  getHandleOnClick: _propTypes.default.func,
  handleKeyDown: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  removeProps: _propTypes.default.object,
  removeFromCartProps: _propTypes.default.object,
  customOnClick: _propTypes.default.func,
  onManagerActionOrStateChange: _propTypes.default.func,
  formatMessage: _propTypes.default.func
};
const RunningComponent = ({
  CustomRunningComponent,
  getClassNames,
  ctaIconSize,
  verifyingProps,
  runningProps,
  formatMessage
}) => {
  if (CustomRunningComponent) {
    return /*#__PURE__*/_react.default.createElement(CustomRunningComponent, {
      formatMessage: formatMessage,
      getClassNames: getClassNames,
      ctaIconSize: ctaIconSize,
      verifyingProps: verifyingProps
    });
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    runningProps,
    disabled: true
  }, "Default Removing");
};
RunningComponent.propTypes = {
  CustomRunningComponent: _propTypes.default.func,
  getClassNames: _propTypes.default.func,
  ctaIconSize: _propTypes.default.number,
  verifyingProps: _propTypes.default.object,
  runningProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func
};
const RevertingComponent = ({
  CustomRevertingComponent,
  getClassNames,
  ctaIconSize,
  removingProps,
  revertingProps,
  formatMessage
}) => {
  if (CustomRevertingComponent) {
    return /*#__PURE__*/_react.default.createElement(CustomRevertingComponent, {
      formatMessage: formatMessage,
      getClassNames: getClassNames,
      ctaIconSize: ctaIconSize,
      removingProps: removingProps
    });
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    revertingProps,
    disabled: true
  }, "Default Reverting");
};
RevertingComponent.propTypes = {
  CustomRevertingComponent: _propTypes.default.func,
  getClassNames: _propTypes.default.func,
  ctaIconSize: _propTypes.default.bool,
  removingProps: _propTypes.default.object,
  revertingProps: _propTypes.default.object,
  formatMessage: _propTypes.default.func
};
const FailureComponent = ({
  CustomUnavailableComponent,
  unavailableFailureCase,
  CustomFailureComponent,
  failureProps
}) => {
  if (CustomUnavailableComponent && unavailableFailureCase) {
    return /*#__PURE__*/_react.default.createElement(CustomUnavailableComponent, null);
  } else if (CustomFailureComponent) {
    return /*#__PURE__*/_react.default.createElement(CustomFailureComponent, failureProps);
  }
  return /*#__PURE__*/_react.default.createElement(_button.default, {
    failureProps,
    disabled: true
  }, "Your Domain Is Unavailable");
};
FailureComponent.propTypes = {
  CustomUnavailableComponent: _propTypes.default.func,
  unavailableFailureCase: _propTypes.default.bool,
  CustomFailureComponent: _propTypes.default.func,
  failureProps: _propTypes.default.object
};
const AddToCartManager = ({
  // Initial Render as Complete or Incomplete.
  ctaComplete = false,
  // Props For Default CTA (SAPI API Calls)
  sapiPostData = {},
  plid = '1',
  basketId = '',
  apiKey = '',
  market = '',
  env = '',
  resellerBaseOverride,
  openButton,
  handleKeyDown,
  getHandleOnClick,
  ctaIconSize,
  getClassNames,
  addProps,
  removeProps,
  verifyingProps,
  removingProps,
  ContinueToCartComponent,
  useDefaultContinueToCart,
  defaultContinueToCartSkipConfig,
  host,
  eidPrefix,
  domain,
  formatMessage,
  stopPropagation,
  // Custom Components - Each of these will be rendered with an onClick function.
  customComponents = {},
  // event given by consumer on any cart state change. onCartStateChange is called with object { state, data: { sapiPost, sapiResponse, error } }.
  onCartStateChange = () => {},
  // Props For AddToCart Component and Remove From Cart Component
  addToCartCustomCta,
  removeFromCartCustomCta,
  // Props For Applying Props Directly to the Default <Button /> Components for Each State
  customButtonProps = {},
  traceId = '',
  showGavelIcon = false
}) => {
  const [status, setStatus] = (0, _react.useState)(ctaComplete ? _CtaStatus.CTA_STATUS.COMPLETE : _CtaStatus.CTA_STATUS.PENDING);
  const [unavailableFailureCase, setUnavailableFailureCase] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setStatus(ctaComplete ? _CtaStatus.CTA_STATUS.COMPLETE : _CtaStatus.CTA_STATUS.PENDING);
  }, [ctaComplete]);
  const {
    addToCartProps = {},
    removeFromCartProps = {},
    runningProps = {},
    revertingProps = {},
    failureProps = {}
  } = customButtonProps;
  const {
    CustomAddToCartComponent,
    CustomRemoveFromCartComponent,
    CustomRunningComponent,
    CustomRevertingComponent,
    CustomFailureComponent,
    CustomUnavailableComponent
  } = customComponents;
  async function customCtaAndStateChange(customCta = () => {}, statusToBe) {
    try {
      await customCta();
      setStatus(statusToBe);
    } catch {
      setStatus(_CtaStatus.CTA_STATUS.FAILED);
    }
  }
  const handleOnClick = async newStatus => {
    if (newStatus === _CtaStatus.CTA_STATUS.RUNNING) {
      setStatus(_CtaStatus.CTA_STATUS.RUNNING);
      // Call SAPI
      try {
        if (addToCartCustomCta) {
          customCtaAndStateChange(addToCartCustomCta, _CtaStatus.CTA_STATUS.COMPLETE);
        } else {
          onCartStateChange({
            state: _CartStatus.CART_STATE.BEFORE_ADD_TO_CART,
            data: {
              sapiPost: sapiPostData
            }
          });
          const result = await (0, _ctas.addProductToCart)({
            sapiPostData,
            plid,
            basketId,
            apiKey,
            market,
            env,
            resellerBaseOverride,
            traceId
          });
          if (result?.cartCount > 0) {
            onCartStateChange({
              state: _CartStatus.CART_STATE.ADD_TO_CART_SUCCESS,
              data: {
                sapiPost: sapiPostData,
                sapiResponse: result,
                domain
              }
            });
            setStatus(_CtaStatus.CTA_STATUS.COMPLETE);
          } else if (result.status === 422 && result.message === 'Domain is unavailable.') {
            onCartStateChange({
              state: _CartStatus.CART_STATE.ADD_TO_CART_UNAVAILABLE,
              data: {
                sapiPost: sapiPostData,
                sapiResponse: result
              }
            });
            setUnavailableFailureCase(true);
            setStatus(_CtaStatus.CTA_STATUS.FAILED);
          } else {
            onCartStateChange({
              state: _CartStatus.CART_STATE.ADD_TO_CART_FAILURE,
              data: {
                sapiPost: sapiPostData,
                sapiResponse: result
              }
            });
            setStatus(_CtaStatus.CTA_STATUS.FAILED);
          }
        }
      } catch (e) {
        onCartStateChange({
          state: _CartStatus.CART_STATE.ADD_TO_CART_FAILURE,
          data: {
            sapiPost: sapiPostData,
            error: e
          }
        });
        setStatus(_CtaStatus.CTA_STATUS.FAILED);
      }
    } else if (newStatus === _CtaStatus.CTA_STATUS.REVERTING) {
      setStatus(_CtaStatus.CTA_STATUS.REVERTING);

      // Call SAPI
      try {
        if (removeFromCartCustomCta) {
          customCtaAndStateChange(removeFromCartCustomCta, _CtaStatus.CTA_STATUS.PENDING);
        } else {
          onCartStateChange({
            state: _CartStatus.CART_STATE.BEFORE_REMOVE_FROM_CART,
            data: {
              sapiPost: sapiPostData
            }
          });
          const results = await (0, _ctas.removeProductFromCart)({
            sapiPackages: sapiPostData.packages,
            plid,
            basketId,
            apiKey,
            market,
            env,
            resellerBaseOverride,
            traceId
          });
          results.forEach(result => {
            if (result.status) {
              onCartStateChange({
                state: _CartStatus.CART_STATE.REMOVE_FROM_CART_SUCCESS,
                data: {
                  sapiPost: sapiPostData,
                  sapiResponse: result,
                  domain
                }
              });
              setStatus(_CtaStatus.CTA_STATUS.PENDING);
            } else {
              onCartStateChange({
                state: _CartStatus.CART_STATE.REMOVE_FROM_CART_FAILURE,
                data: {
                  sapiPost: sapiPostData,
                  sapiResponse: result
                }
              });
              setStatus(_CtaStatus.CTA_STATUS.FAILED);
            }
          });
        }
      } catch (e) {
        onCartStateChange({
          state: _CartStatus.CART_STATE.REMOVE_FROM_CART_FAILURE,
          data: {
            sapiPost: sapiPostData,
            error: e
          }
        });
        setStatus(_CtaStatus.CTA_STATUS.FAILED);
      }
    } else {
      setStatus(newStatus);
    }
  };
  switch (status) {
    case _CtaStatus.CTA_STATUS.PENDING:
      return /*#__PURE__*/_react.default.createElement(AddToCartComponent, {
        formatMessage: formatMessage,
        domain: domain,
        eidPrefix: eidPrefix,
        getClassNames: getClassNames,
        getHandleOnClick: getHandleOnClick,
        handleKeyDown: handleKeyDown,
        ctaIconSize: ctaIconSize,
        addProps: addProps,
        CustomAddToCartComponent: CustomAddToCartComponent,
        openButton: openButton,
        addToCartProps: addToCartProps,
        onManagerActionOrStateChange: () => {
          handleOnClick(_CtaStatus.CTA_STATUS.RUNNING);
        },
        showGavelIcon: showGavelIcon
      });
    case _CtaStatus.CTA_STATUS.RUNNING:
      return /*#__PURE__*/_react.default.createElement(RunningComponent, {
        formatMessage: formatMessage,
        CustomRunningComponent: CustomRunningComponent,
        getClassNames: getClassNames,
        ctaIconSize: ctaIconSize,
        verifyingProps: verifyingProps,
        runningProps: runningProps
      });
    case _CtaStatus.CTA_STATUS.FAILED:
      return /*#__PURE__*/_react.default.createElement(FailureComponent, {
        CustomUnavailableComponent: CustomUnavailableComponent,
        unavailableFailureCase: unavailableFailureCase,
        CustomFailureComponent: CustomFailureComponent,
        failureProps: failureProps
      });
    case _CtaStatus.CTA_STATUS.COMPLETE:
      return /*#__PURE__*/_react.default.createElement(RemoveFromCartComponent, {
        formatMessage: formatMessage,
        CustomRemoveFromCartComponent: CustomRemoveFromCartComponent,
        ContinueToCartComponent: ContinueToCartComponent,
        domain: domain,
        onManagerActionOrStateChange: () => handleOnClick(_CtaStatus.CTA_STATUS.REVERTING),
        stopPropagation: stopPropagation,
        useDefaultContinueToCart: useDefaultContinueToCart,
        host: host,
        defaultContinueToCartSkipConfig: defaultContinueToCartSkipConfig,
        getClassNames: getClassNames,
        eidPrefix: eidPrefix,
        getHandleOnClick: getHandleOnClick,
        handleKeyDown: handleKeyDown,
        ctaIconSize: ctaIconSize,
        removeProps: removeProps,
        removeFromCartProps: removeFromCartProps
      });
    case _CtaStatus.CTA_STATUS.REVERTING:
      return /*#__PURE__*/_react.default.createElement(RevertingComponent, {
        formatMessage: formatMessage,
        CustomRevertingComponent: CustomRevertingComponent,
        getClassNames: getClassNames,
        ctaIconSize: ctaIconSize,
        removingProps: removingProps,
        revertingProps: revertingProps
      });
    default:
      return /*#__PURE__*/_react.default.createElement(AddToCartComponent, {
        formatMessage: formatMessage,
        domain: domain,
        eidPrefix: eidPrefix,
        getClassNames: getClassNames,
        getHandleOnClick: getHandleOnClick,
        handleKeyDown: handleKeyDown,
        ctaIconSize: ctaIconSize,
        addProps: addProps,
        CustomAddToCartComponent: CustomAddToCartComponent,
        openButton: openButton,
        addToCartProps: addToCartProps,
        onManagerActionOrStateChange: () => {
          handleOnClick(_CtaStatus.CTA_STATUS.RUNNING);
        },
        showGavelIcon: showGavelIcon
      });
  }
};
AddToCartManager.propTypes = {
  sapiPostData: _propTypes.default.object,
  plid: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  market: _propTypes.default.string,
  env: _propTypes.default.string,
  resellerBaseOverride: _propTypes.default.string,
  basketId: _propTypes.default.string,
  apiKey: _propTypes.default.string,
  ctaComplete: _propTypes.default.bool,
  openButton: _propTypes.default.bool,
  ctaIconSize: _propTypes.default.number,
  handleKeyDown: _propTypes.default.func,
  getHandleOnClick: _propTypes.default.func,
  getClassNames: _propTypes.default.func,
  addProps: _propTypes.default.object,
  removeProps: _propTypes.default.object,
  verifyingProps: _propTypes.default.object,
  removingProps: _propTypes.default.object,
  ContinueToCartComponent: _propTypes.default.func,
  useDefaultContinueToCart: _propTypes.default.bool,
  defaultContinueToCartSkipConfig: _propTypes.default.bool,
  host: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  domain: _propTypes.default.object,
  stopPropagation: _propTypes.default.bool,
  formatMessage: _propTypes.default.func,
  customComponents: _propTypes.default.shape({
    CustomAddToCartComponent: _propTypes.default.func,
    CustomRemoveFromCartComponent: _propTypes.default.func,
    CustomRunningComponent: _propTypes.default.func,
    CustomRevertingComponent: _propTypes.default.func,
    CustomUnavailableComponent: _propTypes.default.func,
    CustomFailureComponent: _propTypes.default.func
  }),
  onCartStateChange: _propTypes.default.func,
  addToCartCustomCta: _propTypes.default.func,
  removeFromCartCustomCta: _propTypes.default.func,
  customButtonProps: _propTypes.default.shape({
    addToCartProps: _propTypes.default.object,
    removeFromCartProps: _propTypes.default.object,
    runningProps: _propTypes.default.object,
    revertingProps: _propTypes.default.object,
    failureProps: _propTypes.default.object
  }),
  traceId: _propTypes.default.string,
  showGavelIcon: _propTypes.default.bool
};
var _default = exports.default = AddToCartManager;